export default __webpack_public_path__ + "static/media/logo_datacakra.683e7d29.png";